/**
 * Tiện ích cho các section duyệt tin từ trang chủ (carousel / browse).
 *
 * Xây dựng URL điều hướng từ section id, tiêu đề hiển thị theo query,
 * và chuyển bộ lọc sang URLSearchParams (loại bỏ giá trị mặc định).
 */
import { PROPERTY_SORTS, TRANSACTION_TYPES } from '../constants/property';
import { TEXT } from '../languages';
import { buildHomeSearchPath } from './propertySearchParams';

/** Id các section browse trên trang chủ. */
export const HOME_BROWSE_SECTIONS = {
  sale: 'sale',
  rent: 'rent',
  popular: 'popular',
};

/** Param chỉ dùng hiển thị / tracking, không gửi lên API tìm kiếm. */
export const DISPLAY_ONLY_SEARCH_PARAMS = ['section', 'source', 'home_category'];

/**
 * Tạo đường dẫn trang chủ với query tương ứng section carousel.
 *
 * @param {string} sectionId - Một trong HOME_BROWSE_SECTIONS.
 * @returns {string}
 */
export const buildBrowseSectionPath = (sectionId) => {
  const params = {
    section: sectionId,
    source: 'homepage_carousel',
  };

  if (sectionId === HOME_BROWSE_SECTIONS.sale || sectionId === HOME_BROWSE_SECTIONS.rent) {
    params.transaction_type = TRANSACTION_TYPES.sale;
  }

  if (sectionId === HOME_BROWSE_SECTIONS.popular) {
    params.sort = PROPERTY_SORTS.mostViewed;
  }

  return buildHomeSearchPath(params);
};

/**
 * Lấy tiêu đề section hiển thị trên trang kết quả, kèm hậu tố địa điểm nếu có.
 *
 * @param {URLSearchParams} searchParams
 * @returns {string|null} Tiêu đề hoặc null nếu không phải section browse.
 */
export const getBrowseSectionHeading = (searchParams) => {
  const section = searchParams.get('section');
  const province = searchParams.get('province');
  const ward = searchParams.get('ward');
  const district = searchParams.get('district');
  const locationParts = [ward, district, province].filter(Boolean);
  const locationSuffix = locationParts.length ? ` tại ${locationParts.join(', ')}` : '';
  const home = TEXT.home;

  switch (section) {
    case HOME_BROWSE_SECTIONS.rent:
    case HOME_BROWSE_SECTIONS.sale:
      return `${home.sectionSale}${locationSuffix}`;
    case HOME_BROWSE_SECTIONS.popular:
      return `${home.sectionPopular}${locationSuffix}`;
    default:
      return null;
  }
};

/**
 * Chuyển object bộ lọc thành URLSearchParams, bỏ page=1 và sort mặc định.
 *
 * @param {Object} filters
 * @returns {URLSearchParams}
 */
export const buildSearchParamsFromFilters = (filters) => {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (!value) {
      return;
    }

    if (key === 'page' && value === '1') {
      return;
    }

    if (key === 'sort' && value === PROPERTY_SORTS.latest) {
      return;
    }

    params.set(key, value);
  });

  return params;
};
